import axios from 'axios';
import { inlineContent } from '../../assets/js/amplience-sdk';

const formatContent = data => inlineContent(data)[0];

export default class ContentService {
  constructor(endpoint) {
    this.endpoint = endpoint;
  }

  getContent() {
    return axios.get(this.endpoint).then(
      data => formatContent(data),
      err => err
    );
  }

}

export const generateImageUrl = ({ defaultHost, endpoint, name }) => `https://${defaultHost}/i/${endpoint}/${name}.jpeg`;

export const generateVideoUrl = ({ defaultHost, endpoint, name }) => `https://${defaultHost}/v/${endpoint}/${name}/mp4_720p`;



// WEBPACK FOOTER //
// ./src/assets/js/amplience-content-service.js